import { render } from "./language-dropdown.vue?vue&type=template&id=467c9e46&scoped=true"
import script from "./language-dropdown.vue?vue&type=script&lang=js"
export * from "./language-dropdown.vue?vue&type=script&lang=js"

import "./language-dropdown.vue?vue&type=style&index=0&id=467c9e46&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-467c9e46"]])

export default __exports__